import { Measure } from './measure';

export class MeasureDistance extends Measure {

  constructor (map) {
    super(map, 'LineString');
  }

}
